import { useSelector } from "react-redux";
import { RootState } from "@features/store/store";

export const useSelectCurrentTheme = () => useSelector((state: RootState) => state.theme.currentTheme);
